<script lang="ts">
	let { schemas }: { schemas: string } = $props();
</script>

<svelte:head>
	{@html `<script type="application/ld+json">${schemas}</script>`}
</svelte:head>
